export enum FilterActionType {
  enabledUsers = 'Enabled',
  containsIssue  = 'ContainsIssue',
  disabledUsers = 'Disabled',
  allUsers = 'AllUsers'
}
